import axios from 'axios';
import cookies from 'js-cookie';

const getUrl = route => `${API_ENDPOINT}/${route}`;

const getRequestHeaders = (withAuth, cityCode) => {
  const headers = {
    'Content-Type': 'application/json; charset=utf-8',
    'auth-token': withAuth ? cookies.get('auth-token') : '',
  };

  if (cityCode) {
    headers['user-city'] = cityCode;
  }

  return headers;
};

export const fetchAPI = ({
  route,
  method = 'GET',
  data = {},
  withAuth = false,
  params = null,
  responseType = 'json',
  cityCode = null,
}) => {
  return new Promise((resolve, reject) => {
    axios
      .request({
        url: getUrl(route),
        method,
        headers: getRequestHeaders(withAuth, cityCode),
        data,
        params,
        responseType,
      })
      .then(result => {
        resolve(result.data ? result.data : result);
      })
      .catch(err => {
        console.error('error in connecting to network', err);
        console.log('err.response', err.response);

        if (err.response && err.response.status === 401) {
          console.error(route, '401');
          window.location.pathname = '/login';
          reject(err);
        } else if (err.response && err.response.status === 400) {
          reject(err.response.data);
        } else {
          console.log(err.response);
          reject(err);
        }
      });
  });
};

export const getFileFromAPI = ({
  route,
  contentType,
  method = 'GET',
  withAuth = false,
  responseType = 'blob',
}) => {
  return new Promise((resolve, reject) => {
    axios
      .request({
        url: getUrl(route),
        method,
        responseType,
        headers: {
          'Content-Type': contentType,
          'auth-token': withAuth ? cookies.get('auth-token') : '',
          // 'user-city': 'SH',
        },
      })
      .then(res => {
        resolve(res);
      })
      .catch(err => {
        console.error('error in connecting to network', err);

        if (err.response && err.response.status === 401) {
          console.error(route, '401');
          window.location.pathname = '/login';
          reject(err);
        } else if (err.response && err.response.status === 400) {
          reject(err.response.data);
        } else {
          reject(err);
        }
      });
  });
};
